module.exports = __webpack_public_path__ + "img/camera.bb82f287.svg";